import { useEffect, useState } from 'react'
import {
  ENTITY_TYPES,
  ISearchResponse,
  LocationDTO,
} from '@sales-center/common'
import { getBillToDetails } from '../api'
import { unwrapResult } from '@reduxjs/toolkit'
import { useAppDispatch } from '@user/store/hooks/useAppDispatch'
import { setAddOppBillTo } from '@user/store/opportunity/addOpportunity/addOpportunitySlice'

export const useGetBillToLocationOnMount = (
  entityId: number,
  entityType: ENTITY_TYPES,
  skip: number,
  take: number,
) => {
  const [serviceLocations, setLocations] =
    useState<ISearchResponse<LocationDTO>>()

  const dispatch = useAppDispatch()

  const [status, setStatus] = useState<'pending' | 'success' | 'fail'>(
    'pending',
  )

  useEffect(() => {
    let mounted = true

    const execute = async () => {
      if (!entityId || !entityType) {
        return
      }

      try {
        setStatus('pending')

        const result = await dispatch(
          getBillToDetails({ entityId, entityType, skip, take }),
        )

        if (mounted) {
          if (getBillToDetails.fulfilled.match(result)) {
            const locations = unwrapResult(result)
            dispatch(setAddOppBillTo(locations[0]))
            setLocations(locations)
            setStatus('success')
          } else {
            setStatus('fail')
          }
        }
      } catch (error) {
        console.error(error)
        setStatus('fail')
      }
    }
    execute()

    return () => {
      mounted = false
    }
  }, [entityId, entityType, skip, take, dispatch])

  return { billTolocationsStatus: status, serviceLocations }
}
